import { render } from "./Rate.vue?vue&type=template&id=c39e37bc"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"
script.render = render

export default script